<p-breadcrumb [model]="model$ | async | mit: 'breadcrumb' | async" class="c-breadcrumb-desktop"></p-breadcrumb>
